import { Typography } from "@mui/material";
import { TypographyProps } from "./typography-props";


export default function H1({children, ...props}: TypographyProps) {
  return <Typography variant="h1" {...props}>{children}</Typography>
}